import React from 'react';

// nodejs library to set properties for components
import PropTypes from "prop-types";

import { useTranslation } from 'react-i18next';

import CircularProgress from '@mui/material/CircularProgress';
import Card from "@mui/material/Card";
import MDBox from '../components/MDBox';

export default function OthelloWaiting({ ...props }) {

    const { t } = useTranslation();

    const { label, size } = props;

    let width = size != null && size == "sm" ? 120 : "15rem";
    let font = size != null && size == "sm" ? 16 : 18;

    return (

        <Card style={{
            width: width, left: '35%', textAlign: 'center', fontSize: font, fontWeight: 400, position: 'absolute', zIndex: '10'
        }}>
            <MDBox m={2}>
                {label != null && label != "" ? label : t("_cargando")}
                <p />
                <p><CircularProgress color="primary" /></p>
            </MDBox>
        </Card>
    );
}

OthelloWaiting.propTypes = {
    label: PropTypes.string,
    size: PropTypes.oneOf([
        "",
        "sm",
    ])
};

